import { Affix, ButtonMantine, DrawerFooter, Group } from 'ui';

const FullOrderModalFooter = ({
  onResendReceipt,
  onRefund,
  onPrint,
  onCancelPledge,
  posOrderActions,
}: {
  onResendReceipt?: () => void;
  onPrint: () => void;
  onRefund?: () => void;
  onCancelPledge?: () => void;
  posOrderActions?: {
    refund?: boolean;
    resendReceipt?: boolean;
  };
}) => {
  return (
    <Affix w="100%" p="lg" withinPortal={false} bg="white" pos="sticky">
      {posOrderActions ? (
        <Group grow>
          {onRefund && posOrderActions.refund && (
            <ButtonMantine size="xl" color="cerise" onClick={onRefund}>
              Refund
            </ButtonMantine>
          )}
        </Group>
      ) : (
        <DrawerFooter
          primaryButton={
            onResendReceipt ? (
              <DrawerFooter.PrimaryButton
                variant="outline"
                onClick={onResendReceipt}
                miw="fit-content"
              >
                Resend Receipt
              </DrawerFooter.PrimaryButton>
            ) : undefined
          }
          destructiveButton={
            onRefund ? (
              <DrawerFooter.DestructiveButton onClick={onRefund}>
                Refund
              </DrawerFooter.DestructiveButton>
            ) : onCancelPledge ? (
              <DrawerFooter.DestructiveButton onClick={onCancelPledge}>
                Cancel Pledge
              </DrawerFooter.DestructiveButton>
            ) : undefined
          }
        >
          <ButtonMantine fullWidth color="cobalt" size="lg" variant="subtle" onClick={onPrint}>
            Print
          </ButtonMantine>
        </DrawerFooter>
      )}
    </Affix>
  );
};

export { FullOrderModalFooter };
